import { render, staticRenderFns } from "./order-view-payment.vue?vue&type=template&id=3ec68b56&scoped=true&"
import script from "./order-view-payment.vue?vue&type=script&lang=js&"
export * from "./order-view-payment.vue?vue&type=script&lang=js&"
import style0 from "./order-view-payment.vue?vue&type=style&index=0&id=3ec68b56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec68b56",
  null
  
)

export default component.exports